"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownItem = DropdownItem;
exports["default"] = Dropdown;
var _react = _interopRequireWildcard(require("react"));
var _dropdownModule = _interopRequireDefault(require("./dropdown.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _clickAwayListener = _interopRequireDefault(require("../clickAwayListener/clickAwayListener"));
var _LoadingSpinner = _interopRequireDefault(require("@JohnLewisPartnership/jl-design-system/dist/components/loading-spinner/LoadingSpinner"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function Dropdown(_ref) {
  var children = _ref.children,
    open = _ref.open,
    className = _ref.className,
    onClose = _ref.onClose,
    onClick = _ref.onClick,
    onOptionFocus = _ref.onOptionFocus,
    focusedElement = _ref.focusedElement,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    id = _ref.id,
    style = _ref.style;
  var listRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(-1),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var optionIdPrefix = (0, _react.useId)();
  var count = _react["default"].Children.count(children);
  var handleKey = function handleKey(e) {
    if (loading) return;
    var focus = function focus() {
      var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      e.preventDefault();
      setFocused(function (c) {
        var children = listRef.current.children;
        var getNextIndex = function getNextIndex(i) {
          var child = children.item(i);
          if (child.getAttribute('aria-disabled') !== 'true') {
            var _child$scrollIntoView;
            (_child$scrollIntoView = child.scrollIntoView) === null || _child$scrollIntoView === void 0 || _child$scrollIntoView.call(child, {
              block: 'end'
            });
            return i;
          }
        };
        if (reverse) {
          for (var i = c - 1; i > -1; i--) {
            var nextIndex = getNextIndex(i);
            if (nextIndex !== undefined) return nextIndex;
          }
        } else {
          for (var _i = c + 1; _i < children.length; _i++) {
            var _nextIndex = getNextIndex(_i);
            if (_nextIndex !== undefined) return _nextIndex;
          }
        }
        return c;
      });
    };
    switch (e.key) {
      case 'ArrowUp':
        focus(true);
        break;
      case 'ArrowDown':
        focus();
        break;
      case 'Enter':
        e.preventDefault();
        listRef.current.children.item(focused).click();
        setFocused(-1);
        break;
      case 'Escape':
        onClose === null || onClose === void 0 || onClose();
        break;
    }
  };
  (0, _react.useEffect)(function () {
    if (focused > -1) onOptionFocus === null || onOptionFocus === void 0 || onOptionFocus("".concat(optionIdPrefix, "-").concat(focused));
  }, [focused]);
  (0, _react.useEffect)(function () {
    var element = (focusedElement === null || focusedElement === void 0 ? void 0 : focusedElement.current) || listRef.current;
    element === null || element === void 0 || element.addEventListener('keydown', handleKey);
    return function () {
      return element === null || element === void 0 ? void 0 : element.removeEventListener('keydown', handleKey);
    };
  }, [count, focused, open]);
  if (!open) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_clickAwayListener["default"], {
    onClickAway: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames["default"])(_dropdownModule["default"].dropdown, className, _defineProperty({}, _dropdownModule["default"].loading, loading)),
      id: id,
      "aria-busy": loading,
      "aria-live": "polite",
      onClick: onClick,
      style: style,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        ref: listRef,
        role: "listbox",
        className: className,
        tabIndex: focusedElement ? -1 : 0,
        children: _react["default"].Children.map(children, function (child, index) {
          return /*#__PURE__*/_react["default"].cloneElement(child, {
            focused: index === focused,
            id: "".concat(optionIdPrefix, "-").concat(index)
          });
        })
      }), loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(Spinner, {})]
    })
  });
}
function Spinner() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _dropdownModule["default"].spinnerContainer,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingSpinner["default"], {
      centered: true,
      className: _dropdownModule["default"].spinner
    })
  });
}
function DropdownItem(_ref2) {
  var focused = _ref2.focused,
    disabled = _ref2.disabled,
    className = _ref2.className,
    children = _ref2.children,
    id = _ref2.id,
    onClick = _ref2.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
    id: id,
    role: "option",
    "aria-disabled": disabled,
    "aria-selected": focused,
    className: (0, _classnames["default"])(_dropdownModule["default"].dropdownItem, _defineProperty({}, _dropdownModule["default"].focused, focused), className),
    onClick: onClick,
    children: children
  });
}